import React from 'react';
import './Particle.css';

function Particle () {
  return (
    <div className="particle-container">
      <h1>Particle Morph</h1>
      <p className='summary'>I created this website in 2023, this was just a fun little project to better my Javascript and CSS skills. No React was used for this one. I messed around with 3D elements and animation with Three.js and hosted on Netlify. This took me awhile, but was fun to build.</p>
      <h2 className='info'>Tech Used: Javascript, Three.js, CSS, Netlify</h2>
      <h2 className='info'>Link: <a href="https://particle-morph-alyssa.netlify.app/" target="_blank" rel="noopener noreferrer">https://particle-morph-alyssa.netlify.app/</a></h2>
      <h2 className='info'>View my code in Github: <a href="https://github.com/wiserdeveloper/particles-morph/tree/main" target="_blank" rel="noopener noreferrer">https://github.com/wiserdeveloper/particles-morph/tree/main</a></h2>
    </div>
  );
}

export default Particle;